const handleSubmit = (e, currentUrl, title, closeSubscriptionPopup) => {
    e.preventDefault();
    
    var xhr = new XMLHttpRequest();
    var url = "https://api.hsforms.com/submissions/v3/integration/submit/4759838/23b27724-1f57-4198-93a2-f16c7707b019";
    var message = document.getElementById('message');
    var email = document.getElementById('email');

    var data = {
      submittedAt: Date.now(),
      fields: [
        {
          name: "email",
          value: email.value,
        },
      ],
      context: {
        pageUri: currentUrl,
        pageName: title,
      },
    };
    var final_data = JSON.stringify(data);
    xhr.open("POST", url);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        message.innerHTML = '<span class="success">Thank you for your submission.</span>';
        email.value = '';
        closeSubscriptionPopup && setTimeout(closeSubscriptionPopup, 2000)
      } else if (xhr.readyState === 4 && xhr.status === 400) {
        message.innerHTML = '<span class="fail">Your submission is rejected.</span>';
      } else if (xhr.readyState === 4 && xhr.status === 403) {
        message.innerHTML = '<span class="fail">The portal is not allowed to post submissions.</span>';
      } else if (xhr.readyState === 4 && xhr.status === 404) {
        message.innerHTML = '<span class="fail">The form is not found.</span>';
      }
    };
    xhr.send(final_data);
  }

  export default handleSubmit;